import { render, staticRenderFns } from "./BatteryFeatureItem.vue?vue&type=template&id=6fcb526b"
import script from "./BatteryFeatureItem.vue?vue&type=script&lang=js"
export * from "./BatteryFeatureItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports